// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"b467c5a7","215":"11c4fec4","261":"4873768f","479":"aee69592","523":"5e76f908","961":"b467c5a7"}[chunkId] + ".chunk.css";
};